import { useCallback, useState } from "react";

import getNextWeekDates from "b2b/utils/date/getNextWeekDates";

export default function useZadostiOdsouhlaseneWidget() {
  const obdobi = { ...getNextWeekDates() };
  const [zdroj, setZdroj] = useState();
  const onChange = useCallback(zdroj => {
    setZdroj(zdroj);
  }, []);
  return { obdobi, onChange, zdroj };
}
